<template>
  <div type="card-full" style="margin:20px 30px;">
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目合同:</div>
              <div class="view-filelist" v-if="appendList && appendList.length">
                <div v-for="(item,index) in appendList" :key="index" class="view-fileitem">
                  <div class="view-filename" @click="downFile(item.appendurl)">
                    <a :src="uploadAddr + item.appendurl">{{item.appendfilename | toolongOmitted}}</a>
                  </div>
                  <div style="margin-left:30px">
                    {{item.comfullname}}
                  </div>
                </div>
              </div>
              <div v-else class="view-value">无</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import common from '@/mixin/common'
  export default {
    name: 'pjConFile',
    mixins: [common],
    data () {
      return {
          appendList:[]
      }
    },
    created () {
    },
    filters:{
    },
    async mounted () {
      await this.getModel()
    },
    watch: {
      '$route.query.Ptype':async function(newVal,oldVal){
        if(newVal != oldVal){
          await this.getModel()
        }
      }
    },
    methods: {
      async getModel () {
          let res = await request({
            method:'get',
            url:'/xmgl/pds/getpjConFileAppendList',
            params:{projectid:this.$route.query.projectid}
          })
          this.appendList = res
          console.log('-------res---------',res);
      },
    },
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>
